export default {
  common: {
    appName: '银龄康护',
    loading: '加载中...',
    retry: '重试',
    goBack: '返回首页',
    logout: '退出登录',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    search: '搜索',
    delete: '删除',
    edit: '编辑',
    close: '关闭',
    systemError: '系统出现错误，请刷新页面重试',
    weekDays: {
      sun: '日',
      mon: '一',
      tue: '二',
      wed: '三',
      thu: '四',
      fri: '五',
      sat: '六',
    },
  },
  api: {
    error: {
      400: '请求参数错误',
      401: '登录已过期，请重新登录',
      403: '权限不足',
      404: '请求的资源不存在',
      409: '数据冲突，请刷新后重试',
      422: '数据验证失败',
      429: '请求过于频繁，请稍后再试',
      500: '服务器内部错误',
      502: '服务暂不可用',
      503: '服务维护中',
      default: '请求失败（{status}）',
      network: '网络连接失败',
    },
  },
  nav: {
    home: '首页',
    login: '登录',
    dashboard: '仪表盘',
    health: '健康',
    medication: '用药',
    sos: '紧急',
    family: '家人',
    article: '资讯',
    checkin: '打卡',
    settings: '设置',
    about: '关于',
  },
  footer: {
    rights: '版权所有',
    privacy: '隐私政策',
    terms: '服务条款',
  },
  index: {
    hero: {
      title: '银龄康护 - 守护父母健康的智能管家',
      subtitle: '专为老年人设计的健康管理平台，让家人随时了解父母健康状况，让老人轻松管理日常健康',
      cta: '立即开始',
      learnMore: '了解更多',
    },
    features: {
      title: '核心功能',
      health: { title: '健康监测', desc: '实时记录血压、血糖、心率等关键指标，智能异常预警' },
      medication: { title: '用药管理', desc: '用药提醒、药物交互检测，再也不怕漏服错服' },
      sos: { title: '紧急呼叫', desc: '一键SOS，自动通知家人和位置共享' },
      family: { title: '家人关怀', desc: '家人远程关注，异常即时通知，数据共享' },
      article: { title: '健康资讯', desc: '权威健康知识，量身推荐养生指南' },
      checkin: { title: '每日打卡', desc: '简单记录每日状态，养成健康好习惯' },
    },
    elderly: {
      title: '适老化设计',
      desc: '专为老年人打造，操作简单，看得清、点得准',
      font: '大字体显示',
      touch: '大触控区域',
      contrast: '高对比度配色',
    },
  },
  login: {
    title: '银龄康护',
    loginTab: '登录',
    registerTab: '注册',
    name: '姓名',
    email: '邮箱',
    password: '密码',
    role: '我是',
    elderRole: '老人',
    familyRole: '家人',
    bindCode: '关联码',
    bindCodeHint: '请输入老人账户中的关联码，绑定后可查看老人健康数据',
    loginBtn: '登录',
    registerBtn: '注册',
    verifyHint: '注册后将发送验证邮件到您的邮箱',
    error: '操作失败，请重试',
    nameTooShort: '姓名至少2个字符',
    emailInvalid: '请输入有效的邮箱地址',
    passwordTooShort: '密码至少8个字符',
  },
  dashboard: {
    title: '健康仪表盘',
    metrics: {
      bloodPressure: '血压',
      bloodSugar: '血糖',
      heartRate: '心率',
      weight: '体重',
      sleep: '睡眠',
      temperature: '体温',
    },
    quickActions: '快捷操作',
    recordHealth: '记录健康',
    takeMedicine: '吃药打卡',
    sos: '紧急呼叫',
    checkinStatus: '今日打卡',
    checkedIn: '今日已打卡',
    notCheckedIn: '今日尚未打卡',
    goCheckin: '去打卡',
    medicationReminders: '用药提醒',
    noReminders: '暂无用药提醒',
    taken: '已服药',
  },
  health: {
    title: '健康记录',
    inputTitle: '数据录入',
    systolic: '收缩压(mmHg)',
    diastolic: '舒张压(mmHg)',
    bloodSugar: '血糖(mmol/L)',
    heartRate: '心率(bpm)',
    weight: '体重(kg)',
    sleepHours: '睡眠(小时)',
    temperature: '体温(°C)',
    submit: '提交记录',
    trend: '趋势图',
    days: '天',
    aiAnalysis: 'AI健康分析',
    analyze: '开始分析',
    noAnalysis: '点击上方按钮获取AI健康分析报告',
    history: '历史记录',
    noHistory: '暂无历史记录',
    showMore: '显示更多',
    chartLabelSystolic: '收缩压',
    atLeastOneField: '请至少填写一项健康数据',
    addSuccess: '健康记录添加成功',
    addFailed: '健康记录添加失败，请重试',
  },
  medication: {
    title: '用药管理',
    currentPlan: '当前用药计划',
    noMedications: '暂无用药计划',
    addMedication: '添加药物',
    name: '药物名称',
    dosage: '剂量',
    frequency: '频次',
    freqDaily: '每日一次',
    freqTwice: '每日两次',
    freqThree: '每日三次',
    freqWeekly: '每周一次',
    time: '服药时间',
    startDate: '开始日期',
    addBtn: '添加',
    interactionWarning: '药物交互预警',
    noInteraction: '暂无药物交互风险',
    calendar: '用药日历',
    invalidTimeFormat: '时间格式不正确，请使用 HH:mm（例如 08:00, 20:00）',
    addSuccess: '药物添加成功',
    addFailed: '药物添加失败，请重试',
    takeSuccess: '服药打卡成功',
    takeFailed: '服药打卡失败，请重试',
    deleteSuccess: '药物已删除',
    deleteFailed: '药物删除失败，请重试',
    deleteConfirmTitle: '删除药物',
    deleteConfirmMessage: '确定要删除该药物吗？删除后不可恢复。',
  },
  sos: {
    title: '紧急呼叫',
    holdToCall: '长按呼叫',
    holdHint: '长按1秒触发紧急呼叫',
    sent: '紧急呼叫已发送',
    sentDesc: '已通知您的紧急联系人，请保持冷静等待帮助',
    contacts: '紧急联系人',
    location: '当前位置',
    loadingLocation: '正在获取位置...',
    locationUnavailable: '无法获取位置信息',
    history: 'SOS历史记录',
    noHistory: '暂无SOS记录',
    confirmed: '已确认',
    pending: '待确认',
    sendFailed: '紧急呼叫发送失败，请重试',
    confirmFailed: '确认失败，请重试',
    resolveFailed: '解除失败，请重试',
  },
  family: {
    title: '家人关怀',
    members: '已关联家人',
    noMembers: '暂无关联家人',
    bindCode: '关联码',
    bindCodeHint: '将此关联码分享给家人，家人注册时输入即可关联',
    invite: '邀请家人',
    email: '家人邮箱',
    relationship: '与您的关系',
    relSon: '儿子',
    relDaughter: '女儿',
    relSpouse: '配偶',
    relSibling: '兄弟姐妹',
    relOther: '其他',
    inviteBtn: '发送邀请',
    notifications: '通知偏好',
    prefAbnormal: '健康异常通知',
    prefMedication: '用药提醒通知',
    prefSos: '紧急呼叫通知',
    prefWeekly: '周报通知',
    prefCheckin: '打卡通知',
    dataSharing: '数据共享',
    shareDesc: '允许家人查看您的健康数据',
    invalidEmail: '请输入有效的邮箱地址',
    inviteSent: '邀请已发送',
    inviteFailed: '邀请发送失败，请重试',
    elderData: '老人数据',
    viewElderData: '查看老人数据',
    removeConfirmTitle: '移除家人',
    removeConfirmMessage: '确定要移除 {name} 吗？',
    removeSuccess: '家人已移除',
    removeFailed: '移除失败，请重试',
  },
  article: {
    title: '健康资讯',
    search: '搜索文章...',
    noArticles: '暂无相关文章',
    expand: '展开阅读',
    collapse: '收起',
    categories: {
      all: '全部',
      heart: '心血管',
      diabetes: '糖尿病',
      bone: '骨骼',
      sleep: '睡眠',
      nutrition: '营养',
      exercise: '运动',
    },
  },
  checkin: {
    title: '每日打卡',
    feeling: '今日感觉',
    feelings: {
      great: '很好',
      good: '不错',
      normal: '一般',
      bad: '不好',
      terrible: '很差',
    },
    medication: '今日用药',
    yes: '是',
    no: '否',
    diet: '饮食评价',
    dietRatings: {
      good: '好',
      normal: '一般',
      poor: '差',
    },
    exercise: '今日运动',
    mood: '今日心情',
    submit: '提交打卡',
    streak: '连续打卡',
    streakDays: '天',
    calendar: '打卡日历',
    success: '今日打卡成功',
    failed: '打卡失败，请重试',
  },
  settings: {
    title: '设置',
    profile: '个人信息',
    name: '用户名',
    phone: '手机号',
    birthday: '生日',
    emergencyContact: '紧急联系人',
    save: '保存修改',
    preferences: '偏好设置',
    language: '语言',
    theme: '主题',
    light: '亮色',
    dark: '暗色',
    notifications: '通知设置',
    notifHealth: '健康异常通知',
    notifMedication: '用药提醒',
    notifSos: '紧急呼叫通知',
    notifCheckin: '打卡提醒',
    bindCode: '我的关联码',
    changePassword: '修改密码',
    currentPassword: '当前密码',
    newPassword: '新密码',
    changePasswordBtn: '修改密码',
    profileSaved: '个人资料已保存',
    profileSaveFailed: '资料保存失败，请重试',
    passwordChanged: '密码修改成功',
    passwordChangeFailed: '密码修改失败，请重试',
    dangerZone: '危险操作',
    deleteDesc: '删除账户后所有数据将无法恢复，请谨慎操作',
    deleteAccount: '删除账户',
    deleteConfirm: '确定要删除账户吗？此操作不可撤销！',
    subscription: '订阅会员',
    subscriptionDesc: '升级为高级会员，解锁全部健康管理功能',
    monthlyPlan: '月度会员',
    yearlyPlan: '年度会员',
    month: '月',
    year: '年',
    subscribeNow: '立即订阅',
    subscribed: '已订阅',
    bestValue: '最划算',
    subscriptionActive: '您当前已是高级会员',
    subscriptionFree: '您当前为免费会员',
    subscriptionExpires: '到期时间',
    subscriptionPerpetual: '长期有效',
    benefitsTitle: '会员权益',
    benefitAiAnalysis: 'AI 健康分析：智能解读趋势并给出建议',
    benefitFamilySharing: '无限家庭共享：关联多位家人共同关注',
    benefitWeeklyReport: '周报优先：每周生成专属健康周报',
    benefitPrioritySupport: '优先支持：问题反馈优先处理',
    monthlyBilled: '按月计费，随时可取消',
    yearlyBilled: '按年计费，相当于 8.3 折',
    refundPolicy: '订阅后 7 天内可申请退款，退款将原路返回。',
    upgradePrompt: '此功能为高级会员专属，立即订阅解锁全部功能。',
    upgradeBtn: '升级会员',
    aiAnalysisLocked: 'AI 健康分析需订阅高级会员',
    familyLimitReached: '免费用户最多可关联 1 位家人，升级后可关联无限家人。',
  },
  about: {
    title: '关于银龄康护',
    subtitle: '守护父母健康的智能管家',
    intro: '产品介绍',
    introContent: '银龄康护是一款专为老年人设计的健康管理平台，通过智能化的健康监测、用药管理、紧急呼叫等功能，帮助老年人更好地管理自身健康，同时让家人能够远程关注和照顾老人的健康状况。',
    version: '版本信息',
    versionNumber: '版本号',
    buildDate: '构建日期',
    acknowledgements: '致谢',
    contact: '联系方式',
    contactEmail: "q3300404157{'@'}gmail.com",
    privacy: '隐私政策',
    terms: '服务条款',
  },
  notfound: {
    message: '抱歉，您访问的页面不存在',
    goHome: '返回首页',
  },
  privacy: {
    title: '隐私政策',
    sections: {
      collection: {
        title: '信息收集',
        content: '我们仅收集为提供服务所必需的个人信息，包括注册信息（邮箱、姓名）、健康数据（血压、血糖等指标）和设备信息。我们不会收集与服务无关的个人信息。',
      },
      usage: {
        title: '信息使用',
        content: '您的个人信息仅用于提供和改善服务，包括健康数据分析、异常预警、用药提醒等核心功能。我们不会将您的信息用于未经授权的用途。',
      },
      storage: {
        title: '信息存储',
        content: '您的数据存储在安全的云服务器上，采用加密传输和存储。我们会采取合理的技术措施保护您的数据安全，防止未经授权的访问。',
      },
      sharing: {
        title: '信息共享',
        content: '未经您的明确同意，我们不会与第三方共享您的个人信息。仅在您授权家人关联后，相关健康数据才会与关联家人共享。',
      },
      rights: {
        title: '您的权利',
        content: '您有权访问、更正、删除您的个人信息，也有权撤回授权同意。您可以通过应用内的设置功能行使这些权利，或联系我们的客服团队。',
      },
      security: {
        title: '安全保障',
        content: '我们采用行业标准的加密技术和安全措施保护您的数据，包括SSL加密传输、数据加密存储、访问控制等。我们会定期审查和更新安全措施。',
      },
    },
  },
  terms: {
    title: '服务条款',
    sections: {
      acceptance: {
        title: '接受条款',
        content: '使用本应用即表示您同意遵守本服务条款。如果您不同意本条款的任何内容，请停止使用本应用。我们保留随时修改本条款的权利。',
      },
      service: {
        title: '服务说明',
        content: '银龄康护提供健康管理辅助服务，包括健康数据记录、用药提醒、紧急呼叫等功能。本服务仅供参考，不构成医疗建议，不能替代专业医疗服务。',
      },
      accounts: {
        title: '账户管理',
        content: '您需要注册账户才能使用本应用的核心功能。您有责任保管好账户密码，对账户下的所有活动负责。如发现账户被未经授权使用，请立即通知我们。',
      },
      data: {
        title: '数据与隐私',
        content: '我们重视您的隐私保护，详细的数据处理规则请参见我们的隐私政策。您对自己提交的健康数据享有完整的控制权。',
      },
      liability: {
        title: '责任限制',
        content: '本应用提供的健康信息仅供参考，不构成医疗诊断或治疗建议。对于因使用本应用信息而导致的任何损失，我们不承担责任。如有健康问题，请咨询专业医生。',
      },
      changes: {
        title: '条款变更',
        content: '我们可能会不时更新本服务条款。重大变更将通过应用内通知或邮件方式告知您。继续使用本应用即表示您接受更新后的条款。',
      },
    },
  },
  feedback: {
    title: '意见反馈',
    subtitle: '您的反馈对我们非常重要',
    name: '姓名',
    namePlaceholder: '请输入您的姓名（选填）',
    email: '邮箱',
    emailPlaceholder: '请输入您的邮箱',
    subject: '反馈类型',
    subjectGeneral: '通用反馈',
    subjectBug: '问题报告',
    subjectFeature: '功能建议',
    subjectOther: '其他',
    message: '反馈内容',
    messagePlaceholder: '请详细描述您的反馈...',
    submit: '提交反馈',
    submitting: '提交中...',
    success: '反馈发送成功！感谢您的宝贵意见',
    error: '反馈发送失败，请稍后重试',
  },
  verify: {
    loading: '正在验证您的邮箱...',
    success: '验证成功！',
    successDesc: '您的邮箱已验证通过，现在可以登录使用',
    failed: '验证失败',
    failedDesc: '验证链接无效或已过期，请重新发送验证邮件',
    resend: '重新发送验证邮件',
    resending: '发送中...',
    goLogin: '前往登录',
  },
  a11y: {
    toggleTheme: '切换主题',
    selectLanguage: '选择语言',
    selectRole: '选择角色',
  },
  theme: {
    light: '亮色',
    dark: '暗色',
  },
}
